import { Severity } from '@wix/auto_sdk_ecom_checkout';
import { hasSubdivisionShippingError, hasSubdivisionTaxError, hasZipCodeShippingError, hasZipCodeTaxError } from './calculationError.utils';
import { getShippingMethods } from './getShippingMethods';
import { hasShippableItems } from './hasShippableItems';
import { getFastFlowRedirectionReason } from './bi.util';
import { SPECS } from '../controller/SPECS';
export async function shouldNavigateToFastFlowCheckout(_ref) {
  var _checkoutSettings$ter, _checkout$lineItems, _checkoutSettings$che, _checkout$payNowTotal, _checkout$violations, _getShippingMethods, _checkout$lineItems2;
  let {
    checkout,
    prevTotalAmount,
    shouldUpdateShippingAddress,
    checkoutSettings,
    expressCheckoutSettings,
    checkoutService,
    needsShippingMethodSelection,
    biService,
    isMemberLoggedIn,
    shouldUseDeliveryOptionsLibInExpress,
    shouldRedirectToCollectShipping,
    hasShippingZipCodeError,
    hasShippingSubdivisionError,
    shouldUseExpressCheckoutSettings,
    experiments
  } = _ref;
  const getHasCustomField = async () => {
    const useParallelPromisesImprovement = experiments.enabled(SPECS.ImprovePerformanceByParallelPromises);
    let hasRequiredDataExtendedFields;
    let hasRequiredAdditionalInfoField;
    if (useParallelPromisesImprovement) {
      [hasRequiredDataExtendedFields, hasRequiredAdditionalInfoField] = await Promise.all([checkoutService.doesFormHaveRequiredDataExtendedFields(), checkoutService.doesFormHaveRequiredAdditionalInfoField()]);
      return hasRequiredDataExtendedFields || hasRequiredAdditionalInfoField;
    } else {
      const shouldNavigateToFastFlowDueToExtendedFieldsOrAdditionalInfo = (await checkoutService.doesFormHaveRequiredDataExtendedFields()) || (await checkoutService.doesFormHaveRequiredAdditionalInfoField());
      return shouldNavigateToFastFlowDueToExtendedFieldsOrAdditionalInfo;
    }
  };
  const hasTermsAndConditions = shouldUseExpressCheckoutSettings ? Boolean(expressCheckoutSettings == null ? void 0 : expressCheckoutSettings.hasPolicies) : (_checkoutSettings$ter = checkoutSettings.termsAndConditions) == null ? void 0 : _checkoutSettings$ter.enabled;
  const hasLineItemPolicies = Boolean(((_checkout$lineItems = checkout.lineItems) == null ? void 0 : _checkout$lineItems.some(lineItem => {
    var _lineItem$policies;
    return lineItem.policies && ((_lineItem$policies = lineItem.policies) == null ? void 0 : _lineItem$policies.length) > 0;
  })) && (shouldUseExpressCheckoutSettings ? Boolean(expressCheckoutSettings == null ? void 0 : expressCheckoutSettings.requirePolicyAgreement) : (_checkoutSettings$che = checkoutSettings.checkoutPolicyCheckbox) == null ? void 0 : _checkoutSettings$che.show));
  const hasCustomField = await getHasCustomField();
  const hasTaxZipCodeError = hasZipCodeTaxError(checkout);
  const hasTaxSubdivisionError = hasSubdivisionTaxError(checkout);
  const hasShippingZipCodeErrorOld = hasZipCodeShippingError(checkout);
  const hasShippingSubdivisionErrorOld = hasSubdivisionShippingError(checkout);
  const hasTotalAmountMismatchWithLatestSeen = prevTotalAmount !== ((_checkout$payNowTotal = checkout.payNowTotalAfterGiftCard) == null ? void 0 : _checkout$payNowTotal.amount);
  const hasViolations = (_checkout$violations = checkout.violations) == null ? void 0 : _checkout$violations.some(violation => violation.severity === Severity.ERROR || violation.severity === Severity.WARNING);
  const shouldChooseShippingMethod = shouldUpdateShippingAddress && hasShippableItems(checkout) && needsShippingMethodSelection && ((_getShippingMethods = getShippingMethods(checkout, {})) == null ? void 0 : _getShippingMethods.length) !== 1;
  const hasMemberOnlyCheckout = Boolean(!isMemberLoggedIn && ((_checkout$lineItems2 = checkout.lineItems) == null ? void 0 : _checkout$lineItems2.some(lineItem => lineItem.membersOnly)));
  const shouldNavigateToFastFlow = (shouldUseDeliveryOptionsLibInExpress ? shouldRedirectToCollectShipping : shouldChooseShippingMethod) || hasTermsAndConditions || hasCustomField || hasTaxZipCodeError || hasTaxSubdivisionError || (shouldUseDeliveryOptionsLibInExpress ? hasShippingZipCodeError : hasShippingZipCodeErrorOld) || (shouldUseDeliveryOptionsLibInExpress ? hasShippingSubdivisionError : hasShippingSubdivisionErrorOld) || hasTotalAmountMismatchWithLatestSeen || hasLineItemPolicies || hasViolations || hasMemberOnlyCheckout;
  if (shouldNavigateToFastFlow) {
    biService.reportNavigateToFastFlowCheckout({
      checkoutId: checkout.id,
      cartId: checkout.cartId ?? undefined,
      purchaseFlowId: checkout.purchaseFlowId ?? undefined,
      reason: getFastFlowRedirectionReason({
        shouldChooseShippingMethod: shouldUseDeliveryOptionsLibInExpress ? shouldRedirectToCollectShipping : shouldChooseShippingMethod,
        hasTermsAndConditions: Boolean(hasTermsAndConditions),
        hasCustomField: Boolean(hasCustomField),
        hasTaxZipCodeError,
        hasTaxSubdivisionError,
        hasShippingZipCodeError: shouldUseDeliveryOptionsLibInExpress ? hasShippingZipCodeError : hasShippingZipCodeErrorOld,
        hasShippingSubdivisionError: shouldUseDeliveryOptionsLibInExpress ? hasShippingSubdivisionError : hasShippingSubdivisionErrorOld,
        hasTotalAmountMismatchWithLatestSeen,
        hasViolations: Boolean(hasViolations),
        hasLineItemPolicies: Boolean(hasLineItemPolicies),
        hasMemberOnlyCheckout
      })
    });
  }
  return shouldNavigateToFastFlow;
}
//# sourceMappingURL=shouldNavigateToFastFlow.js.map